import React, { FC, useEffect, useState } from 'react'
import RiderItem from './_RiderItem';
import { MenuProps } from 'antd';
import { RiderModel } from '../models/superbit-api-models';

interface Props {
    index: any;
    details: any;
    statuses?: any[];
    config: any;
    actions: any;
    setRiderToPopup: Function;
    onUpdatePaymentsClick: Function;
    onActivateRiderClick: Function;
    setSigningSeen: Function;
    handleCheckBoxRiderChange: (e: any, index: number, riderId: string) => void;
    showAddTreatmentPopup: (customerId: string, policyId: string, type: number) => void;
}

const SigningRiderItem: FC<Props> = (props: Props) => {
    const [riderItem, setRiderItem] = useState<any>(props.details);
    const [riderMenuOptions, setRiderMenuOptions] = useState<MenuProps['items']>([]);
    const [additionalColumns, setAdditionalColumns] = useState<any>(props.config.additionalColumns);


    const onRiderRowClick = (e: any) => {
        var model = new RiderModel();
        console.log('onRiderRowClick-props.details', props.details)
        model.id = props.details.id;
        console.log('onRiderRowClick-model.id', model.id)
        props.setRiderToPopup(model);
    }

    const onUpdatePaymentsClick = (e: any) => {
        var model = new RiderModel();
        model.id = props.details.riderId;
        props.onUpdatePaymentsClick(model);
    }

    const onActivateRiderClick = (e: any) => {
        props.onActivateRiderClick(props.details.riderId);
    }

    const buildMenuOptions = async () => {
        const riderMenuOptionsData: MenuProps['items'] = [];
        riderMenuOptionsData.push(
            {
                label:
                    <li className="pointer rtl"
                        onClick={(e: any) => onRiderRowClick(e)}
                    >
                        צפיה
                    </li>,
                key: '1',
                //disabled: !hasChanges
            }
        );
        riderMenuOptionsData.push(
            {
                label:
                <li className="pointer rtl"
                    onClick={() => { props.showAddTreatmentPopup(riderItem.customerId, '',  1) }}>
                    יצירת משימה לריידר  
                </li>,
                key: '4',
            }
        );

        if (riderItem.rider && riderItem.rider.riderStatusType == 3) {
            riderMenuOptionsData.push(
                {
                    label:
                        <li className="pointer rtl"
                            onClick={onUpdatePaymentsClick}
                        >
                            ערוך תשלום
                        </li>,
                    key: '2',
                    //disabled: !hasChanges
                }
            );
        }
        if (riderItem.rider && riderItem.rider.riderStatusType == 3) {
            riderMenuOptionsData.push(
                {
                    label:
                        <li className="pointer rtl"
                            onClick={onActivateRiderClick}
                        >
                            הפעלת ריידר
                        </li>,
                    key: '3',
                    //disabled: !hasChanges
                }
            );
        }
        setRiderMenuOptions(riderMenuOptionsData);
    }

    useEffect(() => {
        buildMenuOptions();
    }, []);

    const onHandlerCheckBoxRider = (e: any, riderId: string = '') => {
        console.log('props.key', props.index)
        props.handleCheckBoxRiderChange(e, props.index, riderItem.id);
    }




    return (
        <RiderItem
            riderMenuOptions={riderMenuOptions}
            riderItem={riderItem}
            additionalColumns={additionalColumns}
            handleCheckBoxRiderItemChange={onHandlerCheckBoxRider}
        />
    )
}

export default SigningRiderItem